var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedback2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feedback-2--Streamline-Ultimate.svg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.4017 5.91797H34.8135C36.5765 5.91797 38.0058 7.34727 38.0058 9.1104V28.8792C38.0058 30.6423 36.5765 32.0717 34.8135 32.0717H18.3025L9.87069 37.8962C8.81189 38.6277 7.36724 37.8697 7.36724 36.5828V32.0717H5.18804C3.42491 32.0717 1.99561 30.6423 1.99561 28.8792V9.1104C1.99561 7.34727 3.42491 5.91797 5.18802 5.91797H8.76519",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.8431 1.81966L16.7456 5.91716L20.8431 10.0147",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.369 20.9197C14.1089 20.9197 15.5193 19.5093 15.5193 17.7695C15.5193 16.0296 14.1089 14.6191 12.369 14.6191C10.6292 14.6191 9.21875 16.0296 9.21875 17.7695C9.21875 19.5093 10.6292 20.9197 12.369 20.9197Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M17.6528 25.8145C16.9632 23.5547 14.8269 21.8603 12.3731 21.8603C9.9192 21.8603 7.78301 23.5547 7.09326 25.8145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.4765 20.9197C29.2163 20.9197 30.6268 19.5093 30.6268 17.7695C30.6268 16.0296 29.2163 14.6191 27.4765 14.6191C25.7367 14.6191 24.3262 16.0296 24.3262 17.7695C24.3262 19.5093 25.7367 20.9197 27.4765 20.9197Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.7603 25.8145C32.0705 23.5547 29.9343 21.8603 27.4805 21.8603C25.0267 21.8603 22.8905 23.5547 22.2007 25.8145",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback2);
export default __webpack_public_path__ + "static/media/feedback-2.aaef681b1b61b18adaaa11e813460261.svg";
export { ForwardRef as ReactComponent };